/* PFDE Hotjar only: respect Shopify analytics permission; never grant consent. */
(function () {
  'use strict';
  if (window.__pfdeHotjarInitialized) return;
  window.__pfdeHotjarInitialized = true;
  var started = false;
  var attempts = 0;
  function checkPermission() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return;
    var allowed = privacy.analyticsProcessingAllowed();
    // Reload on withdrawal to stop this page's already running recorder.
    if (!allowed) {
      if (started) window.location.reload();
      return;
    }
    if (started) return;
    // Do not double-install if an app or another integration already owns Hotjar.
    if (window._hjSettings || document.querySelector('script[src*="static.hotjar.com/c/hotjar-"]')) return;
    started = true;
    window.hj = window.hj || function () { (window.hj.q = window.hj.q || []).push(arguments); };
    window._hjSettings = { hjid: 3826868, hjsv: 6 };
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://static.hotjar.com/c/hotjar-3826868.js?sv=6';
    document.head.appendChild(script);
  }
  function initialize() {
    var shopify = window.Shopify;
    if (shopify && shopify.customerPrivacy) { checkPermission(); return; }
    if (shopify && typeof shopify.loadFeatures === 'function') {
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) checkPermission();
      });
      return;
    }
    // Bounded wait for Shopify bootstrap; fail closed if unavailable.
    if (++attempts < 40) window.setTimeout(initialize, 250);
  }
  document.addEventListener('visitorConsentCollected', checkPermission);
  initialize();
})();
